import React, { FC } from 'react'
import { FlowersUSPContent as SharedFlowersUSPContent } from '@moonpig/web-shared-products'
import { ProductModule } from '../types'
import { ProductModuleSection } from '../ProductModuleSection'

type Props = ProductModule & {
  isPlant: boolean
}

export const FlowersUSPContent: FC<Props> = ({ isPlant, ...rest }) => {
  return (
    <ProductModuleSection {...rest}>
      <SharedFlowersUSPContent isPlant={isPlant} />
    </ProductModuleSection>
  )
}
